import useCreditor from './useCreditor';

function useEarlyLateFeesDetails() {
  const { paymentTimingAdjustments } = useCreditor();

  if (!paymentTimingAdjustments || Object.keys(paymentTimingAdjustments).length === 0) {
    return {
      doWeSetEarlyPaymentsInAccountingSystem: false,
      doWeSetLateFeesInAccountingSystem: false,
      paymentTimingAdjustments: {},
    };
  }

  const doWeSetEarlyPaymentsInAccountingSystem =
    paymentTimingAdjustments?.earlyPaymentDiscount?.applieFeesPolicy ===
    'APPLY_FEES_IN_INTEGRATION';
  const doWeSetLateFeesInAccountingSystem =
    paymentTimingAdjustments?.latePaymentFees?.applieFeesPolicy === 'APPLY_FEES_IN_INTEGRATION';

  return {
    doWeSetEarlyPaymentsInAccountingSystem,
    doWeSetLateFeesInAccountingSystem,
    paymentTimingAdjustments,
  };
}

export default useEarlyLateFeesDetails;
